import { Trans } from "@lingui/react/macro";
import { ActionIcon, Modal } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconCopy } from "@tabler/icons-react";

import { GetBookingsItem } from "@/shared/api/generated/schemas";

import DuplicateBookingForm from "./duplicate-booking-form";

export default function DuplicateBooking({
  booking,
}: {
  booking: GetBookingsItem;
}) {
  const [opened, { open, close }] = useDisclosure(false);

  return (
    <>
      <ActionIcon onClick={open}>
        <IconCopy />
      </ActionIcon>

      <Modal
        opened={opened}
        onClose={close}
        closeOnClickOutside={false}
        closeOnEscape={false}
        size="xl"
        title={<Trans>Kopier booking</Trans>}
      >
        <DuplicateBookingForm booking={booking} onClose={close} />
      </Modal>
    </>
  );
}
